<template>
  <div class="div" v-loading="loading">
    <!-- <div class="title">库区管理</div> -->
    <div class="div-top">
      <el-button icon="el-icon-plus" type="primary" @click="handleAdd"
        >新建年检记录</el-button
      >
      <el-button
        icon="el-icon-minus"
        type="danger"
        @click="handleDetele(selectedRows)"
        :disabled="selectedRows.length === 0"
        >删除</el-button
      >
      <el-input
        v-model="searchData.DeviceName"
        clearable
        placeholder="请输入设备编号或名称"
        style="width: 300px; margin-left: 10px"
      ></el-input>
      <el-date-picker
        v-model="searchData.AnnualInspectionDate"
        type="monthrange"
        style="width: 300px; margin-left: 10px"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="handleDateChange"
      >
      </el-date-picker>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px"
        >查询</el-button
      >
      <el-button
        type="primary"
        @click="handleReminderDaysEdit"
        style="margin-left: 10px"
        >设置年检提醒天数</el-button
      >
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        height="calc(100% - 40px)"
        @selection-change="handleSelect"
      >
        <el-table-column
          label=""
          width="50"
          type="selection"
          :selectable="selectable"
        >
        </el-table-column>
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>
        <el-table-column label="年检设备编号" align="center" prop="DeviceCode">
        </el-table-column>
        <el-table-column label="年检设备编号" align="center" prop="device_name">
        </el-table-column>
        <el-table-column
          label="年检供应商"
          align="center"
          prop="AnnualInspectionCompany"
        >
        </el-table-column>

        <el-table-column
          label="年检日期"
          align="center"
          prop="AnnualInspectionDate"
        >
          <template slot-scope="scope">
            {{
              scope.row.AnnualInspectionDate
                ? moment(scope.row.AnnualInspectionDate).format('YYYY-MM-DD')
                : ''
            }}
          </template>
        </el-table-column>
        <el-table-column label="年检有效期起始日" align="center" prop="sDate">
          <template slot-scope="scope">
            {{
              scope.row.sDate
                ? moment(scope.row.sDate).format('YYYY-MM-DD')
                : ''
            }}
          </template>
        </el-table-column>
        <el-table-column label="年检有效期终止日" align="center" prop="eDate">
          <template slot-scope="scope">
            {{
              scope.row.eDate
                ? moment(scope.row.eDate).format('YYYY-MM-DD')
                : ''
            }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              @click="handleDetele([scope.row])"
              style="color: #f78989"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    <EditForm ref="EditForm" @success="handleSearch" />
    <ReminderDaysForm ref="ReminderDaysForm" @success="handleSearch" />
  </div>
</template>
<script>
import EditForm from './EditForm'
import moment from 'moment'
import { mapState } from 'vuex'
import ReminderDaysForm from './ReminderDaysForm'
export default {
  data() {
    return {
      moment,
      searchData: {
        DeviceName: '',
        AnnualInspectionDate: [],
      },
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
    }
  },
  props: {},
  components: { EditForm, ReminderDaysForm },
  methods: {
    handleDateChange(value) {
      // 无论是否为同一个月，结束日期都应为月末日期
      if (value && value.length === 2) {
        const startDate = moment(value[0])
        const endDate = moment(value[1])
        // 设置开始日期为选择月份的第一天
        const firstDay = startDate.startOf('month').format('YYYY-MM-DD')
        // 设置结束日期为选择月份的最后一天
        const lastDay = endDate.endOf('month').format('YYYY-MM-DD')
        this.$set(this.searchData, 'AnnualInspectionDate', [firstDay, lastDay])
      }
    },
    handleDetele(rows) {
      let ids = rows.map((item) => item.Id)
      this.$confirm(`此操作将永久删除该年检信息, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http
            .post(
              '/Base_DeviceTreeManage/Device_AnnualInspection/DeleteData',
              ids
            )
            .then((resJson) => {
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('删除成功')
                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    selectable() {
      // if (row.State == "0") {
      //   return true;
      // } else {
      //   return false;
      // }
      return true
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/Base_DeviceTreeManage/Device_AnnualInspection/GetDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'AnnualInspectionDate',
          SortType: 'Desc',
          Search: [
            {
              Condition: 'DeviceType',
              Keyword: this.devTreeSearch.DeviceType || '',
            },
            {
              Condition: 'BuildingId',
              Keyword: this.devTreeSearch.BuildingId || '',
            },
            {
              Condition: 'InstallationArea',
              Keyword: this.devTreeSearch.InstallationArea || '',
            },
            {
              Condition: 'DeviceName',
              Keyword: this.searchData.DeviceName,
            },
            {
              Condition: 'AnnualInspectionDate',
              Keyword: this.searchData.AnnualInspectionDate
                ? this.searchData.AnnualInspectionDate.join(',')
                : '',
            },
          ],
        })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.tableData = resJson.Data
            this.pagination.total = resJson.Total
            this.$nextTick(() => {
              if (this.$refs.table) {
                this.$refs.table.clearSelection()
              }
            })
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      this.$refs.EditForm.openForm('新建年检记录')
    },

    handleEdit(row) {
      this.$refs.EditForm.openForm('编辑年检记录', row)
    },
    handleReminderDaysEdit() {
      this.$refs.ReminderDaysForm.openForm('维护年检提醒天数')
    },
  },
  mounted() {},
  created() {
    this.getDataList()
  },
  computed: {
    ...mapState(['devTreeSearch']),
  },
  watch: {
    devTreeSearch() {
      this.handleSearch()
    },
  },
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 30px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
</style>
